// extracted by mini-css-extract-plugin
export default {"layout":"MobileLayout_layout__nARD4","content":"MobileLayout_content__NhSHL"};